export default __webpack_public_path__ + "static/media/logotype-bf.3812d25b.svg";